import React from "react";

import Dialog from "components/Dialog";
import Divider from "components/Divider";
import Button from "components/Button";
import Header from "../Header";

import classes from "./styles.module.scss";

const PaymentsDisabled = ({ isOpen, onClose }) => (
    <Dialog open={isOpen} closeActions={onClose} classes={{ paperClass: classes.paymentModalContainer }}>
        <Header onClose={onClose} />
        <Divider />
        <div className={classes.disabledBody}>
            <h3>Purchases temporarily unavailable</h3>
            <p>
                Credit purchases are temporarily disabled during the Volta SNAP 1.0.0 rollout. You can still use any
                credits already on your account. Check back soon — purchases will be enabled for all users shortly.
            </p>
            <Button onClick={onClose} type="hollow">
                Close
            </Button>
        </div>
    </Dialog>
);

export default PaymentsDisabled;
